import React, { ChangeEvent, useEffect, useState } from "react";

import { Organization } from "../common/ObjectTypes";
import { toast } from "react-toastify";
import { MoonLoader } from "react-spinners";
import AddEditOrg from "./AddEditOrg";
import { useNavigate, useParams } from "react-router-dom";
import {
  createOrganization,
  deleteOrganization,
  getOrganizationById,
  updateOrganization,
} from "../../api/organizations/organizationsApi";

type ManageAddEditOrgProps = {
  existingOrg: boolean;
};

const ManageAddEditOrg = ({ existingOrg }: ManageAddEditOrgProps) => {
  const { v4: uuidv4 } = require("uuid");
  const [pageLoaded, setPageLoaded] = useState(false);
  const navigate = useNavigate();
  const { id: orgId } = useParams<{ id: string }>();
  const [organization, setOrganization] = useState<Organization>({
    name: "",
    organizationId: "",
    rowVersion: "",
  });
  useEffect(() => {
    const loadOrgDetails = async () => {
      try {
        const org = await getOrganizationById(orgId ? orgId : "");
        setOrganization(org);
      } catch (error) {
        console.log(error);
      }
    };
    if (existingOrg) loadOrgDetails();
    setPageLoaded(true);
  }, [pageLoaded, existingOrg, orgId]);

  const handleChange = (e: any) => {
    setOrganization((prev: Organization) => ({
      ...prev,
      name: e.target.value,
    }));
  };
  const handleSave = async () => {
    const updatedOrg = {
      name: organization.name,
      organizationId: organization.organizationId || uuidv4(),
    };
    try {
      if (existingOrg) {
        await updateOrganization(updatedOrg);
        toast.success("Organization updated.", {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 2500,
        });
      } else {
        await createOrganization(updatedOrg);
        toast.success("Organization created.", {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 2500,
        });
      }
      navigate("/organizations");
    } catch (error) {
      console.error("Error saving organization:", error);
      toast.error("There was an error saving the organization.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
    }
  };

  const handleCancelEdit = () => {
    setOrganization({
      name: "",
      organizationId: "",
    });
    navigate("/organizations");
  };

  const handleDelete = async () => {
    try {
      await deleteOrganization(
        organization.organizationId ? organization.organizationId : ""
      );
      setOrganization({
        name: "",
        organizationId: "",
      });
      toast.success("Org was deleted.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };
  return !pageLoaded ? (
    <div>
      <MoonLoader color="#9EB45B" />
    </div>
  ) : (
    <div className="">
      <AddEditOrg
        organization={organization}
        onCancelEdit={handleCancelEdit}
        onChange={handleChange}
        onSave={handleSave}
        onDelete={handleDelete}
        existingOrg={existingOrg}
      />
    </div>
  );
};

export default ManageAddEditOrg;
